import JLINCAPI from 'lib/JLINCAPI'

const aServer = new JLINCAPI({ urlPrefix: JLINC_A_API })

export default aServer

DEBUG.aServer = aServer
